import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=824fa0c2"
import script from "./FileReader.vue?vue&type=script&lang=js"
export * from "./FileReader.vue?vue&type=script&lang=js"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=824fa0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports